/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { CustomerPreview } from './CustomerPreview.js';
import {
    CustomerPreviewFromJSON,
    CustomerPreviewFromJSONTyped,
    CustomerPreviewToJSON,
} from './CustomerPreview.js';

/**
 * 
 * @export
 * @interface CustomersListResponse
 */
export interface CustomersListResponse {
    /**
     * 
     * @type {Array<CustomerPreview>}
     * @memberof CustomersListResponse
     */
    data?: Array<CustomerPreview>;
    /**
     * 
     * @type {number}
     * @memberof CustomersListResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomersListResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof CustomersListResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof CustomersListResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the CustomersListResponse interface.
 */
export function instanceOfCustomersListResponse(value: object): boolean {
    return true;
}

export function CustomersListResponseFromJSON(json: any): CustomersListResponse {
    return CustomersListResponseFromJSONTyped(json, false);
}

export function CustomersListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomersListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(CustomerPreviewFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function CustomersListResponseToJSON(value?: CustomersListResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(CustomerPreviewToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

